import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-dialog',
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.scss']
})
export class DialogComponent {
  default: boolean = true;
  title: string = "";
  contentTitle: string = "";
  contentMessage: string = "";
  contentImageMessage: string = "";
  btnShow: boolean = false;
  isImage: boolean = false;
  isImageData: boolean = false;
  btnConfirmText: string = null;
  btnCancelText: string = null;
  isImagePath: string = null;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _dialogRef: MatDialogRef<DialogComponent>) {
    if (data) {
      this.default = data.default || this.default;
      this.title = data.title || this.title;
      this.contentTitle = data.contentTitle || this.contentTitle;
      this.contentImageMessage = data.contentImageMessage || this.contentImageMessage;
      this.contentMessage = data.contentMessage || this.contentMessage;
      this.btnConfirmText = data.btnConfirmText || this.btnConfirmText;
      this.btnCancelText = data.btnCancelText || this.btnCancelText;
      this.btnShow = data.btnShow || this.btnShow;
      this.isImage = data.isImage || this.isImage;
      this.isImageData = data.isImageData || this.isImageData;
      this.isImagePath = data.isImagePath || this.isImagePath;
    }
  }
  ngAfterViewInit(): void {
    document.getElementById("cancelFocus").focus();
  }
  onCancel() {
    this._dialogRef.close("Cancel");
  }
  onConfirm() {
    this._dialogRef.close("Confirm");
  }
}
